import { RiWhatsappFill } from "react-icons/ri";

const WHATSAPP_URL = "https://wa.me/919755010858";

// A plain anchor rather than MUI's IconButton + Tooltip: those two components
// were the only reason @mui/material, @mui/system, @emotion and popper were in
// the bundle, which is a lot of JavaScript for one round green button. The
// native title attribute gives the same hover hint.
const ChatSection = () => (
  <div className="fixed bottom-3 right-5 z-50">
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      title="WhatsApp at +91 97550 10858"
      aria-label="Chat with us on WhatsApp at +91 97550 10858"
      className="flex h-16 w-16 items-center justify-center rounded-full bg-[#25d366]
                 text-3xl text-white shadow-lg transition-transform hover:scale-110
                 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                 focus-visible:outline-[#25d366]"
    >
      <RiWhatsappFill aria-hidden="true" />
    </a>
  </div>
);

export default ChatSection;
